import ScreenWrapper from "@/components/ScreenWrapper"
import ProjectDetailSidebar from "@/pages/contracten/contract_detail/ProjectDetailSidebar"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"
import { createFileRoute, Outlet } from "@tanstack/react-router"
import {
  DetailSidebar,
  LayoutWithSidebar,
  useLayoutConfig,
} from "toptaal-shared"

export const Route = createFileRoute("/beheer/contracten/$contractId")({
  component: RouteComponent,
  beforeLoad: () => checkOrganizationPermissions("read", "projects"),
})

function RouteComponent() {
  const layoutConfig = useLayoutConfig()

  return (
    <ScreenWrapper className="!px-0">
      <LayoutWithSidebar
        rightPanelClassName={layoutConfig.rightPanelClassName}
        disableRightPanelSuspense={layoutConfig.disableRightPanelSuspense}
        sidebar={
          <DetailSidebar
            goBackLabel="Contracten"
            goBackRoute="/beheer/contracten"
          >
            <ProjectDetailSidebar />
          </DetailSidebar>
        }
      >
        <Outlet />
      </LayoutWithSidebar>
    </ScreenWrapper>
  )
}
